import React from "react";

import MailConfirmation from "../components/auth/MailConfirmation";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";

const Login = () => {
  return (
    <div>
      <Header />
      <MailConfirmation />
      <Footer />
    </div>
  );
};

export default Login;
